import {useContext, useEffect, useState} from "react";
import {FormControlLabel, Grid, Radio, Typography} from "@mui/material";
import {useTranslation} from "react-i18next";
import {useForm} from "react-hook-form";
import { useRecoilState } from "recoil";
import {additionalInfoState} from "../../../../../search-repair-shop/state";
import {FormRadioGroup, FormTextField} from "../../../../../common/form-fields-wrappers";
import {updateAdditionalInfo} from "../../../../../search-repair-shop/rsSearch.actions";
import {SET_SNACKBAR} from "../../../../../common/utils";
import {GlobalContext} from "../../../../../../../util/state/GlobalContextProvider";
import { setValuesInForm } from "../../../../constants";
import TabWrapper from "../TabWrapper/TabWrapper";
import { AdditionalInfoForm } from "./types";

const AdditionalInfo = () => {
    const {t} = useTranslation(['network', 'translation']);
    const { dispatchGlobalData } = useContext(GlobalContext);
    const [additionalInfo, setAdditionalInfo] = useRecoilState(additionalInfoState);

    const additionalInfoForm = useForm<AdditionalInfoForm>({defaultValues: {
        id: additionalInfo?.id ?? '',
        chargingSite: additionalInfo?.chargingSite ? 'Yes' : 'No',
        note: additionalInfo?.note ?? '',
        howToIta: additionalInfo?.howToIta ?? '',
        howToEng: additionalInfo?.howToEng ?? '',
    }});

    const onSubmit = (data: any) => {
        const reqParameters = {
            id: additionalInfo.id,
            chargingSite: data.chargingSite === "Yes",
            note: data.note,
            howToIta: data.howToIta,
            howToEng: data.howToEng,
        }

        updateAdditionalInfo(reqParameters)
            .then( (res:any) => { setAdditionalInfo(res.additionalInfo) })
            .catch(() => { dispatchGlobalData(SET_SNACKBAR.ERROR) });
    }

    const [isOpened, setIsOpened] = useState(true);

    useEffect(() => {
        if (!!additionalInfo) {
            setValuesInForm(additionalInfo, additionalInfoForm, {chargingSite: (cs) => cs ? 'Yes' : 'No'});
        }
    },[additionalInfo]);

    return (
        <TabWrapper infoForm={additionalInfoForm} onSubmit={onSubmit} expanded={setIsOpened}>
            <>
                <Grid item xs={12} sm={4} md={3}>
                    <FormRadioGroup
                        control={additionalInfoForm.control}
                        name="chargingSite"
                        label={t("rsDetail.additionalInfo.form.label.chargingSite")}
                        disabled={!isOpened}
                    >
                        <FormControlLabel
                            value="Yes"
                            control={<Radio/>}
                            label={t("rsDetail.additionalInfo.form.label.yes")}
                        />

                        <FormControlLabel
                            value="No"
                            control={<Radio />}
                            label={t("rsDetail.additionalInfo.form.label.no")}
                        />
                    </FormRadioGroup>
                </Grid>
                <Grid item xs={12} sm={8} md={9}>
                    <FormTextField
                        disabled={!isOpened}
                        control={additionalInfoForm.control}
                        name="note"
                        label={t("rsDetail.additionalInfo.form.label.note")}
                    />
                </Grid>
                <Grid item container xs={12} marginTop={2} display="flex" flexDirection="column" gap={1}>
                    <Typography variant="bodySmall" color="grey">{t('rsDetail.additionalInfo.form.label.notes')}</Typography>
                    <Grid item xs={12}>
                        <FormTextField
                            disabled={!isOpened}
                            control={additionalInfoForm.control}
                            name="howToIta"
                            label={t("rsDetail.additionalInfo.form.label.howToIta")}
                            multiline
                            rows={6}
                            variant="outlined"
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <FormTextField
                            disabled={!isOpened}
                            control={additionalInfoForm.control}
                            name="howToEng"
                            label={t("rsDetail.additionalInfo.form.label.howToEng")}
                            multiline
                            rows={6}
                            variant="outlined"
                        />
                    </Grid>
                </Grid>
            </>
        </TabWrapper>
    )
}

export default AdditionalInfo;
